<template>
  <div class="openInstrument">
    <div class="left">
      <Left />
    </div>
    <div class="right">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Left from './left'
export default {
  name: 'Instrument',
  components: {
    Left
  },
  created() {
  }
}
</script>

<style lang="less" scoped>
.openInstrument {
  display: flex;
  justify-content: space-between;
  width: 1220px;
  margin: 18px auto;
  .left {
    width: 180px;
    // height: 1183px;
    background: #FAFAFA;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  }
  .right {
    width: 1020px;
  }
}
</style>